/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Close: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M2 2L22 22' stroke='currentColor' fill='transparent' strokeWidth='2' strokeLinecap='round' />
    <path d='M2 22L22 2' stroke='currentColor' fill='transparent' strokeWidth='2' strokeLinecap='round' />
  </React.Fragment>
)
